import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {MUTATION_KEYS} from '@/queryClient'
import {AxiosError, AxiosResponse} from 'axios'
import {PatientExtended} from '@/features/patients/types'
import {httpUpdatePatient, HttpUpdatePatientOptions, HttpUpdatePatientPayload} from './patients.http'

export const useUpdatePatient = ({
    urlParams,
    params,
    options
}: {
    urlParams: HttpUpdatePatientOptions['urlParams']
    params: HttpUpdatePatientOptions['params']
    options?: UseMutationOptions<
        AxiosResponse<PatientExtended>,
        AxiosError<{errors: {field: string; rule: string}[]}>,
        HttpUpdatePatientPayload
    >
}) =>
    useMutation({
        ...options,
        mutationKey: [MUTATION_KEYS.UPDATE_PATIENT],
        mutationFn: payload => httpUpdatePatient({urlParams, params, payload})
    })
